module.exports = __webpack_public_path__ + "static/media/check-icon.1e094342.svg";